module.exports = __webpack_public_path__ + "static/media/home7.cfed7f9e.jpg";